import { Component } from 'react';

export class Kissmetrics extends Component {
  /**
   * Push event and event data to kissmetrics
   * @param array data
   */
  static push = (data) => {
    if (window && window._kmq) {
      window._kmq.push(data);
    }
  };

  /**
   * Connect to Kissmetrics
   */
  componentDidMount() {
    this._kmq = this._kmq || [];
    this._kmk = this._kmk || process.env.KISSMETRICS_TRACKING_API_KEY;

    function _kms(u) {
      setTimeout(() => {
        let d = document;
        let node = d.getElementsByTagName('script')[0];
        let script = d.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = u;
        node.parentNode.insertBefore(script, node);
      }, 1);
    }

    _kms('//i.kissmetrics.io/i.js');
    _kms(`//scripts.kissmetrics.io/${this._kmk}.2.js`);
  }

  render() {
    return null;
  }
}
